//@core
const { getStore } = require('core/storeHelper');

// @ vendor
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/actionTypes');
const { BROKER_REIMBURSE_FUND_TOTAL, BROKER_REIMBURSE_FUND_PARTIAL } = require('constants/index');
const {
    WEALTH_FUNDS_PARTIAL_REIMBURSEMENT
} = require('constants/flagBasedFeatures');

function setInitialState() {
    return Immutable.Map().merge({
      valid: false,
      amount: 0,
      amountIsValid: true,
      amountDirty: false,
      participation: 0,
      participationAmount: 0,
      type: BROKER_REIMBURSE_FUND_TOTAL,
      reimburseFund: {
        account: {
          balance: { currency: '' }
        }
    }
    })
}

function validateStep(step) {
    const maxReimburseInvestmentPercentage = getStore().getState().brokerMyInvestments.get('maxFundsPartialReimbursementPercentage');
    const immMyInvestments = getStore().getState().brokerMyInvestments;
    const contractNumber = step.getIn(['reimburseFund','contractNumber']);
    const actualfund = immMyInvestments.getIn(['products','funds','stocks'], Immutable.fromJS({})).find(fund => fund.get('contractNumber') === contractNumber);
    const maxAmount = actualfund.getIn(['totalValueEur','amount']) * ( maxReimburseInvestmentPercentage / 100);
    const totalParticipation = step.getIn(['reimburseFund', 'fundParticipations']);
    const customCategoryId2 = step.getIn(['reimburseInvestment', 'customCategoryId2']);
    const ffFundsPartialReimbursement = getStore().getState().flagBasedFeatures.get(WEALTH_FUNDS_PARTIAL_REIMBURSEMENT);
    const validateAmount = step.get('type') === BROKER_REIMBURSE_FUND_TOTAL || step.get('amount')>0 && step.get('amount') <= maxAmount
    const validateParticipation = step.get('participation') > 0 && step.get('participation') <= totalParticipation
    const isPartialReimbursement = step.get('type') === BROKER_REIMBURSE_FUND_PARTIAL;
    const isCustomCategoryValid = customCategoryId2 !== '2';

    let validation;

    if (ffFundsPartialReimbursement && isPartialReimbursement && isCustomCategoryValid) {
        validation = validateAmount;
    } else if (ffFundsPartialReimbursement && isPartialReimbursement) {
        validation = validateParticipation;
    } else {
        validation = validateAmount;
    }

    return step.merge({
        valid: validation,
        amountIsValid: validation,
        amountDirty: false,
    });
}

function wizardSuscriptionStep1(state = setInitialState(), action) {
    switch (action.type) {
        case actionTypes.BROKER_WIZARD_REIMBURSE_FUND_SET_AMOUNT:
            return state.merge({
                amount: action.payload.amount,
                amountDirty: true,
            });
        case actionTypes.BROKER_WIZARD_REIMBURSE_FUND_VALIDATE_STEP:
            return validateStep(state);
        case actionTypes.BROKER_WIZARD_REIMBURSE_FUND_SET_TYPE:
            return state.merge({
                type: action.payload.type,
                amount: action.payload.amount
            });
        case actionTypes.BROKER_WIZARD_REIMBURSE_FUND_SET_PARTICIPATION:
            return state.merge({
                participation: action.payload.participation,
                participationAmount: action.payload.participationAmount,
                amount: action.payload.participationAmount
            });
    }

    return state;
}

module.exports = wizardSuscriptionStep1;
